
// App version
// export const Version = "2.5.736"
export const Version = "2.5.740"




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/version.ts